export enum UnsavedChangesModalResult {
    Apply,
    Discard,
    Cancel
}
